import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import MpciApiClient from '../Common/services/MpciApiClient'

const PartyMasterService = {
    create: (data, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.PARTY_MASTER_POST,
      data,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  update: (data, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'PUT',
      UaeMpciApiUrls.PARTY_MASTER_PUT,
      data,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

    delete: (id, onSuccess, onError) => {
    MpciApiClient.del(
      `${UaeMpciApiUrls.PARTY_MASTER_DELETE}/${id}`,
      {},
      onSuccess,
      onError
    )
  },

    getById: (id, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.PARTY_MASTER_GET,
      { id },
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

  search: (query, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'GET',
      `${UaeMpciApiUrls.PARTY_MASTER_SEARCH}?query=${encodeURIComponent(query)}`,
      null,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  },

    clone: (id, onSuccess, onError) => {
    MpciApiClient.post(
      `${UaeMpciApiUrls.PARTY_MASTER_CLONE}/${id}`,
      {},
      onSuccess,
      onError
    )
  }
}

export default PartyMasterService
